// 사용자 업로드 리소스 CRUD — 통합 public.resource 테이블(is_system=false, owner=본인) 사용.
//  구분자는 is_system(전역 여부) — user_type은 제거됨(리소스는 단일 소유, 공유는 리액션 URL로).
//  DB kind는 대문자(MUSIC/SFX/EFFECT/STICKER). 클라 내부는 소문자 kind로 다룸(경계에서 변환).
//  외부 인터페이스는 구 resource_type(music/sound_effect/lottie/gif)도 수용 → 내부에서 kind로 정규화.
//  file_name/creator_id 컬럼은 제거됨 — file_name은 storage_key basename에서 파생.
import { supabase } from "@/utils/supabase";

// 구 resource_type ↔ 신 kind(소문자) 매핑
const KIND_BY_RTYPE = { music: "music", sound_effect: "sfx", lottie: "effect", gif: "sticker" };
const RTYPE_BY_KIND = { music: "music", sfx: "sound_effect", effect: "lottie", sticker: "gif" };
const toKind = (rt) => KIND_BY_RTYPE[rt] || rt; // 소문자 kind
const basename = (key) => (key || "").split("/").pop() || "";

const SELECT = "id,kind,label,storage_key,duration_ms,file_size,created_at";

// 소비처 호환: kind 소문자화 + file_name/resource_type 파생
const decorate = (r) => {
  const kind = (r.kind || "").toLowerCase();
  return { ...r, kind, file_name: basename(r.storage_key), resource_type: RTYPE_BY_KIND[kind] || kind };
};

// resourceType 생략 시 본인 전체. is_system=false(내 업로드)만, RLS가 owner=본인만 반환.
const list = async (resourceType) => {
  let q = supabase.from("resource").select(SELECT).eq("is_system", false);
  if (resourceType) q = q.eq("kind", toKind(resourceType).toUpperCase());
  const { data, error } = await q.order("created_at", { ascending: false });
  if (error) throw error;
  return (data || []).map(decorate);
};

// 본인 리소스 생성(is_system=false 기본). kind(신) 또는 resourceType(구) 수용. DB엔 대문자 kind 저장.
const create = async ({ kind, resourceType, label, storageKey, durationMs, fileSize }) => {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("E_NOT_LOGGED_IN");

  const { data, error } = await supabase
    .from("resource")
    .insert({
      kind: toKind(kind || resourceType).toUpperCase(),
      owner_id: user.id,
      label: label || null,
      storage_key: storageKey,
      duration_ms: durationMs ?? null,
      file_size: fileSize ?? null,
    })
    .select(SELECT)
    .single();
  if (error) throw error;
  return decorate(data);
};

// 표시 이름 변경 (본인 소유 행만 — RLS)
const update = async (id, { label }) => {
  const { data, error } = await supabase.from("resource").update({ label: label || null }).eq("id", id).select(SELECT).single();
  if (error) throw error;
  return decorate(data);
};

const remove = async (id) => {
  const { error } = await supabase.from("resource").delete().eq("id", id);
  if (error) throw error;
};

export default { list, create, update, remove };
